import QuestionContent from './QuestionContent';

export default QuestionContent;
